export enum Settings {
  BATCH_TIME = 1,
  BATCH_MAXIMUM_NUMBER_OF_ORDERS = 2,
  DELIVERY_TIME = 4,
}
